/** Shopify CDN: Minification failed

Line 154:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 155:0 Transforming const to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 148:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 149:0 Transforming const to the configured target environment ("es5") is not supported yet

**/
/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

jQuery(document).ready(function($){
   jQuery(document).on('submit',".product-form, .product-item__action-list",function(e){
      e.preventDefault();
      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: jQuery(this).serialize(),
        dataType: 'json',
        success: function(res) {
             jQuery("#cart-success-modal").addClass('xoo-cp-active');
             jQuery("#xoo-cp-success-msg").html('<span class="xoo-cp-icon-check"></span>Product toegevoegd aan je winkelmand'); 
        },
        error: function(){
          jQuery("#xoo-cp-success-msg").html('<span class="xoo-cp-icon-check"></span>er is iets fout gegaan');
        }
      });
  });
  
    jQuery(document).on('click',function(event){
       var modal = document.getElementById("cart-success-modal");
        if (event.target.className == 'xoo-cp-active' || event.target.classList.contains('xoo-cp-active')) {
           
              modal.classList.remove('xoo-cp-active');
        }
    });

    jQuery(document).on('click','.xoo-cp-close', function(event){
      event.preventDefault();
       var modal = document.getElementById("cart-success-modal");
       modal.classList.remove('xoo-cp-active');
    });
    
  if($('.image-popup-vertical-fit').length > 0){
    $('.image-popup-vertical-fit').magnificPopup({
    	type: 'image',
      mainClass: 'mfp-with-zoom', 
      gallery:{
    			enabled:true
    		},
    
      zoom: {
        enabled: true, 
    
        duration: 300, // duration of the effect, in milliseconds
        easing: 'ease-in-out', // CSS transition easing function
    
        opener: function(openerElement) {
    
          return openerElement.is('img') ? openerElement : openerElement.find('img');
      }
    }
  

});
  }
var btn = $('#button');
  
btn.on('click', function(e) {
  e.preventDefault();
  $('html, body').animate({scrollTop:0}, '500');
});


$('.readmore').click(function (event) {
  event.preventDefault();
  var descriptionFull = document.querySelector('.product-description-full');
  descriptionFull.style.display = 'block';
  var descriptionShort = document.querySelector('.product-description-short');
  descriptionShort.style.display = 'none';
});
$('.readless').click(function (event) {
  event.preventDefault();
  var descriptionFull = document.querySelector('.product-description-full');
  descriptionFull.style.display = 'none';
  var descriptionShort = document.querySelector('.product-description-short');
  descriptionShort.style.display = 'block';
});  

  if(jQuery(".employee__btn").length > 0){
      jQuery(".employee__btn").removeAttr('href');
      (function() {
            document.querySelector(".employee__btn").addEventListener("click", function() {
              window.tidioChatApi.show();
              window.tidioChatApi.open();
            });
          })();
  }
  
$(window).scroll(function() {   
    var scroll = $(window).scrollTop();

    if (scroll >= 50 && checkifmobile() === true) {
        $(".header.header--inline ").addClass("header-sticky");
        $("#shopify-section-announcement-bar .mbardiv").addClass("announcement-sticky");
    }else{
      $(".header.header--inline ").removeClass("header-sticky");
        $("#shopify-section-announcement-bar .mbardiv").removeClass("announcement-sticky");
    }
}); //missing );

   

$(window).scroll(function() {
  var scrollTop = $(window).scrollTop();
  if(checkifmobile() === false && window.innerWidth  >= 992 && $('.product-block-list__item--gallery').length > 0){
    const galleryHeight = $('.product-block-list__item--gallery').outerHeight();
const galleryBottom = $('.product-block-list__item--gallery').offset().top + galleryHeight;
    var stickyElement = $('.product-block-list__item--info');
    var stickyTop = $('.product-block-list__item--gallery').offset().top + galleryHeight - stickyElement.outerHeight();
    var element = $('#shopify-section-header');
    var windowHeight = $(window).height();
    
    var elementOffset = element.offset().top;
    var visibleHeight = Math.min(windowHeight, 20 + elementOffset + element.outerHeight() - scrollTop) - Math.max(0, elementOffset - scrollTop);
   if(visibleHeight < 30){
      visibleHeight = 30;
    }
    if(visibleHeight > 173){
      visibleHeight = 173;
    }
    
  // if (scrollTop > 70 && scrollTop > stickyTop && scrollTop < galleryBottom - 550) {
  //     stickyElement.css({
  //       position: 'fixed',
  //       top: 2+visibleHeight+'px',
  //       bottom: '0',
  //       width: '610px',
  //       right: '95px',
  //     });
  //   } else if (scrollTop  >= galleryBottom - 550) {
  //   stickyElement.removeAttr('style');
  //     stickyElement.css({
  //       position: 'absolute',
  //       top: 'auto',
  //       bottom: '0',
  //       height: 'auto',
  //     });
  //   }else if(scrollTop > 70){
  //     stickyElement.css({
  //       position: 'fixed',
  //       top: 2+visibleHeight+'px',
  //       bottom: '0',
  //       width: '610px',
  //       right: '95px',
  //     });
  //   }
  
    // Reset the position of the sticky element to its default
    // if (scrollTop === 0) {
    //   stickyElement.removeAttr('style');
    // }
  }
  });
});
 document.dispatchEvent(new 
CustomEvent("swym:collections-loaded"));


function checkifmobile() {
   if (navigator.userAgent.match(/Android/i)
   || navigator.userAgent.match(/webOS/i)
   || navigator.userAgent.match(/iPhone/i)
   || navigator.userAgent.match(/iPad/i)
   || navigator.userAgent.match(/iPod/i)
   || navigator.userAgent.match(/BlackBerry/i)
   || navigator.userAgent.match(/Windows Phone/i)) {
      return true ;
   } else {
      return false ;
   }
}


function swymCallbackFn(swat){
    // your API calls go here
    document.addEventListener("swym:collections-loaded", function(){
      swat.initializeActionButtons("<<Collections Grid PARENT Selector >>");
    })
  }
  if(!window.SwymCallbacks){
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(swymCallbackFn);